import React, { useCallback }     from 'react';
import classNames                 from 'classnames';
import SwiperCore,
{
    Navigation,
    Pagination,
    Lazy,
    Autoplay
}                                 from 'swiper';
import { Swiper, SwiperSlide }    from 'swiper/react';
import { useSelector }            from 'react-redux';
import farma                      from '../../assets/images/farma.png';
import BannerBaseImg              from '../../assets/images/Banner-base.png';
import ArrowRight                 from '../../assets/icon/ArrowRight';
import ArrowLeft                  from '../../assets/icon/ArrowLeft';
import useMediaQuery              from '../../hooks/useMediaQuery';
import { heroBannerListSelector } from '../../store/selectors/HeroBanner';
import { MODALS }                 from '../../constants';
import { useModal }               from '../../utils/useModal';
import style                      from './BannerBase.module.scss';
import 'lazysizes';

SwiperCore.use([ Lazy ]);

function BannerBase() {
    const isDesktop = useMediaQuery('(min-width: 1100px)');

    const bannerList = useSelector(heroBannerListSelector);

    // bannerList = bannerList.filter(item => item.type === 'banner');

    const { toggleModal } = useModal();

    const togglePopup = useCallback(() => {
        // eslint-disable-next-line no-shadow
        const checkToken = document.cookie.split('; ').find(row => row.startsWith('token='))?.split('=')[1];

        if (checkToken) {
            toggleModal({ id: MODALS.POPUP_DRAG });
        } else  {
            const expiryDate = new Date();

            expiryDate.setTime(expiryDate.getTime() + (2 * 24 * 60 * 60 * 1000));
            document.cookie = `recipe=true; expires=${expiryDate.toUTCString()}; path=/`;
            toggleModal({ id: MODALS.POPUP_LOGIN });
        }
    }, []);

    return (
        <section className={style['banner-inner']}>
            <div className={classNames(style.container, style.relative)}>

                { bannerList.length > 0 ?
                    <div className={style['banner-wrapper']}>
                        <div className={classNames(style.banner)}>
                            <Swiper
                                className={style.swiper}
                                spaceBetween={isDesktop ? 20 : 0}
                                slidesPerView={1}
                                autoplay={{
                                    delay                : 3000,
                                    disableOnInteraction : false
                                }}
                                loop
                                lazy
                                preloadImages={false}
                                modules={[ Navigation, Pagination, Lazy, Autoplay ]}
                                pagination={{
                                    clickable : true
                                }}
                                navigation={{
                                    prevEl : '.button-prev',
                                    nextEl : '.button-next'
                                }}
                            >

                                { bannerList?.map((item, i) => (
                                    <SwiperSlide
                                        /* eslint-disable-next-line react/no-array-index-key */
                                        key={i}
                                        className={style.slide}
                                    >
                                        <a href={item?.lnk && item.lnk} className={classNames(style['banner-slide'], style.first)}>
                                            <img
                                                data-src={item?.url ? item?.url : BannerBaseImg}
                                                height={331}
                                                alt=''
                                                className='swiper-lazy'
                                                style={{
                                                    minHeight : 331
                                                }}
                                            />

                                            {/* {*/}
                                            {/*    item?.showButton &&*/}
                                            {/*    <Link to={item?.lnk}>*/}
                                            {/*        { item?.buttonText }*/}
                                            {/*    </Link>*/}
                                            {/* }*/}

                                            <div className='swiper-lazy-preloader' />
                                        </a>
                                    </SwiperSlide>
                                ))
                                }

                                {/* <SwiperSlide*/}
                                {/*    className={style.slide}*/}
                                {/* >*/}
                                {/*    <div className={classNames(style['banner-slide'])}>*/}
                                {/*        <img loading="lazy" data-src={img}   className='swiper-lazy' alt='' />*/}
                                {/*        <h1>*/}
                                {/*            Наші фармацевти готові надати онлайн <span>консультацію</span> безкоштовно*/}
                                {/*        </h1>*/}

                                {/*        <a href='/'>*/}
                                {/*            Як це працює*/}
                                {/*        </a>*/}
                                {/*    </div>*/}
                                {/* </SwiperSlide>*/}

                                {/* <SwiperSlide*/}
                                {/*    className={style.slide}*/}
                                {/* >*/}
                                {/*    <div className={classNames(style['banner-slide'], style.last)}>*/}
                                {/*        <img loading="lazy" data-src={imgCar}   className='swiper-lazy' alt='' />*/}
                                {/*        <h1>*/}
                                {/*            Наші фармацевти <br /> готові надати онлайн консультацію безкоштовно*/}
                                {/*        </h1>*/}

                                {/*        <a href='/'>*/}
                                {/*            Як це працює*/}
                                {/*        </a>*/}
                                {/*    </div>*/}
                                {/* </SwiperSlide>*/}
                            </Swiper>
                        </div>

                        <>
                            <button className={classNames(style.prev, 'button-prev')}>
                                <ArrowLeft />
                            </button>
                            <button className={classNames(style.next, 'button-next')}>
                                <ArrowRight />
                            </button>
                        </>

                        {
                            isDesktop &&

                            <div onClick={togglePopup} className={style.card}>
                                {/* <div className={style.bg} />*/}
                                {/* <h2>Замовте ліки по фото рецепта </h2>*/}

                                {/* <img loading="lazy"  src={card} alt='' />*/}

                                <div className={style.card__inner}>
                                    <h2 className={style['bg_farma-title']}>Замовте <br />ліки по<br /> фото<br /> рецепта </h2>
                                </div>

                                <img

                                    height={322}
                                    src={farma}
                                    className={classNames(style.img)}
                                    alt='' />

                                <div className={style.arrow}>
                                    <ArrowLeft />
                                </div>
                            </div>
                        }
                    </div>
                    : <img

                            data-src={BannerBaseImg}
                            height={331}
                            alt=''
                            className='swiper-lazy'
                            style={{
                                minHeight : 331
                            }}
                    />
                }
            </div>
        </section>
    );
}

export default React.memo(BannerBase);
